'use strict';

/* Blendet unter jedem <textarea maxlength> im uebergebenen Formular einen live mitlaufenden
   Zeichenzaehler ein (z.B. "420 / 1.000 Zeichen", siehe registration.charCounter in locallang.xlf -
   das {current}/{max}-Template kommt bewusst per data-char-counter-template vom Server, nicht
   hartkodiert aus dem Script, damit es uebersetzt werden kann). Wird sowohl von der
   Selbstregistrierung (chip-map-registration.js, New.html) als auch von "Mein Eintrag"
   (chip-map-edit.js, Edit.html) genutzt - beide Formulare haben Textareas mit denselben
   maxlength-Grenzen (z.B. profileDe/profileEn). update() laeuft auch einmal direkt beim Laden,
   nicht erst beim ersten "input": nach einem Validierungsfehler-Reload stehen bereits Werte in den
   Feldern, der Zaehler soll von Anfang an den korrekten Stand zeigen statt "0 / 1000". */
export function initCharCounters(form) {
    if (!form) {
        return;
    }

    const template = form.getAttribute('data-char-counter-template') || '{current} / {max}';
    // Tausendertrennzeichen passend zur Seitensprache (das <html lang="de-DE"|"en-US"> aus dem
    // Seiten-Layout, siehe Chat) - die Feldlabels weisen "max. 1.000 Zeichen" bereits mit
    // Tausenderpunkt aus (siehe registration.field.standort.profileDe in locallang.xlf), der
    // Zaehler soll dazu konsistent bleiben statt "1000" ohne Trennzeichen anzuzeigen.
    const numberFormat = new Intl.NumberFormat(document.documentElement.lang || undefined);

    form.querySelectorAll('textarea[maxlength]').forEach(function (textarea) {
        const max = parseInt(textarea.getAttribute('maxlength'), 10);
        if (!max) {
            return;
        }

        const counter = document.createElement('span');
        counter.className = 'cc-char-counter';
        counter.setAttribute('aria-live', 'polite');
        textarea.insertAdjacentElement('afterend', counter);

        function update() {
            counter.textContent = template
                .replace('{current}', numberFormat.format(textarea.value.length))
                .replace('{max}', numberFormat.format(max));
        }

        textarea.addEventListener('input', update);
        update();
    });
}
